import { create } from 'zustand';

import { AuthStore } from './types';
import { persist } from 'zustand/middleware';

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      auth: undefined,
      setAuth: (user) => set({ auth: user }),
      updateAuth: (partial) =>
        set((state) => ({
          auth: state.auth ? { ...state.auth, ...partial } : state.auth,
        })),
    }),
    {
      name: 'auth-storage',
      version: 1,
    }
  )
);
